module.exports = __webpack_public_path__ + "static/media/keshav.0e99a8e8.jfif";